export enum PATHNAME_TITLES {
  'current-dispatch' = 'My Current Dispatch',
  'work-info' = 'Work Information',
  'downloadable-forms' = 'Downloadable Forms',
  'my-profile' = 'My Profile',
  'contact-email' = "Update Email Address",
  'ratings' = 'Ratings',
  'capabilities' = 'Capabilities',
  'trades' = 'Trades',
  'tickets' = 'Tickets',
  'suspensions' = 'Suspensions/Restrictions',
  'dispatch-history' = 'My Dispatch History',
  'gang-work-info' = 'Gang Work',
  'buttons' = 'Buttons',
  'union-board-trd' = 'Union Boards',
  'union-board-ma' = 'Union Boards',
  'union-board-rr' = 'Union Boards',
  'union-board-n' = 'Union Boards',
  'union-board-dk' = 'Union Boards',
  'union-board-ws' = 'Union Boards',
  'union-board-wm' = 'Union Boards',
  'union-board-cw' = 'Union Boards',
  'union-board-ckdh' = 'Union Boards',
  'union-board-fah' = 'Union Boards',
  'union-board-gan' = 'Union Boards',
  'union-board-sqc' = 'Union Boards',
  'union-board-lin' = 'Union Boards',
  'union-board-ts' = 'Union Boards',
  'union-board-hld' = 'Union Boards',
  'union-board-vis' = 'Union Boards',
  'union-board-sur' = 'Union Surplus Board',
  'casual-board' = 'Casual Boards',
  'telephone-board-fa' = 'First Aid Telephone Board',
  'telephone-board-sq' = 'Squamish Telephone Board',
  'telephone-board-ckd' = 'Dock Checkers Telephone Board',
  'telephone-plugin' = 'Plug-In for Shift',
  'benefits-links' = 'Benefits Links',
  'vessel-forecast' = 'Vessel Forecast',
  'welcome' = 'MyBCMEA',
  'training-history' = 'Training History',
  'jda-reports' = 'JDA Reports',
  'faqs' = 'Frequently Asked Questions',
  'payroll-history' = 'Payroll History',
  'doa-forecast' = 'DOA Forecast',
  'doa-forecast-stats' = 'DOA Forecast Stats',
  'current-lines-dispatch' = 'My Current Lines Dispatch',
  'doa-forecast/doa-admin' = 'DOA Forecast Stats',
  'lines-work-info' = 'Lines Work Information',
  'availability-administration-shifts' = 'DOA Admin',
  'availability-administration-employee' = 'Availability Admin',
  'hall-chalk-boards' = 'Hall Chalk Boards',
  'hall-chalk-boards-new' = 'Hall Chalk Boards (New)',
  'gang-way-report' = 'DOA Gangway Report',
  'gang-way-report-results' = 'Gangway Availability Report',
  'dispatch-availability-list-report' = 'Dispatch Availability List',
  'union-audit-report' = 'DOA Union Audit Report',
  'union-audit-report-results' = 'DOA Union Audit Report',
  'casual-audit-report' = 'DOA Casual Audit Report',
  'casual-audit-report-results' = 'DOA Casual Audit Report',
  'contact-us' = 'Contact Us',
  'dispatch-history-results' = 'Dispatch History',
  'doa' = 'Declaration of Availability',
  'payroll-history-results' = 'Payroll History',
  'usage' = 'Usage History',
  'usage-results' = 'Usage History',
  'security-question' = 'Update Security Question'
}

export enum MOBILE_PATHNAME_TITLES {
  'current-dispatch' = 'My Current Dispatch',
  'work-info' = 'Work Information',
  'downloadable-forms' = 'Downloadable Forms',
  'my-profile' = 'My Profile',
  'contact-email' = "Update Email Address",
  'ratings' = 'Ratings',
  'capabilities' = 'Capabilities',
  'trades' = 'Trades',
  'tickets' = 'Tickets',
  'suspensions' = 'Suspens./Restrict',
  'dispatch-history' = 'My Dispatch History',
  'gang-work-info' = 'Gang Work',
  'buttons' = 'Buttons',
  'union-board-trd' = 'Union Boards',
  'union-board-ma' = 'Union Boards',
  'union-board-rr' = 'Union Boards',
  'union-board-n' = 'Union Boards',
  'union-board-dk' = 'Union Boards',
  'union-board-ws' = 'Union Boards',
  'union-board-wm' = 'Union Boards',
  'union-board-cw' = 'Union Boards',
  'union-board-ckdh' = 'Union Boards',
  'union-board-fah' = 'Union Boards',
  'union-board-gan' = 'Union Boards',
  'union-board-sqc' = 'Union Boards',
  'union-board-lin' = 'Union Boards',
  'union-board-ts' = 'Union Boards',
  'union-board-hld' = 'Union Boards',
  'union-board-vis' = 'Union Boards',
  'union-board-sur' = 'Union Surplus Board',
  'casual-board' = 'Casual Boards',
  'telephone-board-fa' = 'First Aid Telephone Board',
  'telephone-board-sq' = 'Squamish Telephone Board',
  'telephone-board-ckd' = 'Dock Checkers Telephone Board',
  'telephone-plugin' = 'Plug-In for Shift',
  'benefits-links' = 'Benefits Links',
  'vessel-forecast' = 'Vessel Forecast',
  'welcome' = 'MyBCMEA',
  'training-history' = 'Training History',
  'jda-reports' = 'JDA Reports',
  'faqs' = 'Frequently Asked Questions',
  'payroll-history' = 'Payroll History',
  'doa-forecast' = 'DOA Forecast',
  'doa-forecast-stats' = 'DOA Forecast Stats',
  'current-lines-dispatch' = 'My Current Lines Dispatch',
  'doa-forecast/doa-admin' = 'DOA Forecast Stats',
  'lines-work-info' = 'Lines Work Info.',
  'availability-administration-shifts' = 'DOA Admin',
  'availability-administration-employee' = 'Availability Admin',
  'hall-chalk-boards' = 'Hall Chalk Boards',
  'hall-chalk-boards-new' = 'Hall Chalk Boards (New)',
  'gang-way-report' = 'DOA Gangway Report',
  'gang-way-report-results' = 'Gangway Availability Report',
  'dispatch-availability-list-report' = 'Dispatch Availability List',
  'union-audit-report' = 'DOA Union Audit Report',
  'union-audit-report-results' = 'DOA Union Audit Report',
  'casual-audit-report' = 'DOA Casual Audit Report',
  'casual-audit-report-results' = 'DOA Casual Audit Report',
  'contact-us' = 'Contact Us',
  'dispatch-history-results' = 'Dispatch History',
  'doa' = 'Declaration of Availability',
  'payroll-history-results' = 'Payroll History',
  'usage' = 'Usage History',
  'usage-results' = 'Usage History',
  'security-question' = 'Update Security Question'
}

export const COMPLEX_PATHNAME_TITLES = ["telephone-board", "union-board", "availability-administration"]
